module.exports = __webpack_public_path__ + "static/media/raleighv2.2e24c41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/raleighv2.png
// module id = 536
// module chunks = 0